<template>
  <div id="families">
    <v-container class="pa-0">
      <v-layout>
        <router-link to="/family/add">
        <v-flex class="xs12 sm12 mb-5">
          <v-btn fab absolute right class="mr-3 pf-btn-fab">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
        </router-link>
      </v-layout>
    </v-container>
    <h5 class="pf-sub-head mb-3">Search Families</h5>
    <v-layout wrap row class="mb-4">
      <v-flex sm6 class="pr-2">
        <v-text-field ref="searchField" append-icon="search" @keyup.enter="searchFamilies('family')" @click:append="searchFamilies('family')" v-model="query.family" label="Search by Family / PPN" hint="Type atleast 3 characters to search, PPN should be entered fully" :disabled="isSearchBoxDisabled"></v-text-field>
      </v-flex>
      <v-flex sm6 class="pl-2">
        <v-select v-model="query.status" clearable label="Search by Status" :items="profileStatusList" @change="searchFamilies('status')"></v-select>
      </v-flex>
    </v-layout>
    <v-flex xs12>
    </v-flex>
    <v-card>
      <v-data-table
        :headers="headers"
        :items="familyList"
        :pagination.sync="pagination"
        no-data-text="No results, Search for families"
        class="pf-data-table"
      >
        <template v-slot:items="props">
          <tr :class="{ 'pf-row-highlighted': props.item.agency && props.item.agency.length > 1 }">
            <td>{{ props.item.name }}</td>
            <td><a title="Account Info" @click="accountInfo(props.item)">{{ props.item.nickname }}</a></td>
            <td>
              {{ props.item.human.length && props.item.human[0].user && props.item.human[0].user.username ? props.item.human[0].user.username : '--' }}
              <!-- <v-edit-dialog
                :return-value.sync="props.item.nickname"
                lazy
                :large="props.item.nickname.length > 0"
                :persistent="props.item.nickname.length > 0"
                @save="nicknameUpdate(props.item)"
              > {{ props.item.nickname ? props.item.nickname : '--' }}
                <template v-slot:input>
                  <v-text-field
                    v-model.trim="props.item.nickname"
                    :rules="[required]"
                    label="Nickname"
                    single-line
                    @keyup.enter="nicknameUpdate(props.item)"
                  ></v-text-field>
                </template>
              </v-edit-dialog> -->
            </td>
            <td width="100px">
              <v-menu
                v-model="menu[familyList.indexOf(props.item)]"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="dateFormate(props.item.joined_date)"
                    persistent-hint
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker color="#019d8c" :max="new Date().toISOString().substr(0, 10)" :value="props.item.joined_date ? props.item.joined_date.substr(0, 10) : ''" @input="changeJoinDate($event, props.item, 'join')"></v-date-picker>
              </v-menu>
            </td>
            <td width="100px">
              <v-menu
                v-model="waitingPicker[familyList.indexOf(props.item)]"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    :value="dateFormate(props.item.waiting_for)"
                    persistent-hint
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker color="#019d8c" :max="new Date().toISOString().substr(0, 10)" :value="props.item.waiting_for.substr(0, 10)" @input="changeJoinDate($event, props.item, 'wait')"></v-date-picker>
              </v-menu>
            </td>
            <td>
              <v-edit-dialog
                :return-value.sync="props.item.ppn"
                lazy
                large
                @save="statusUpdate(props.item, 'ppn')"
              > {{ props.item.ppn }}
                <template v-slot:input>
                  <v-text-field
                    v-model="props.item.ppn"
                    :rules="[max8chars]"
                    label="Edit"
                    single-line
                    @keyup.enter="statusUpdate(props.item, 'ppn')"
                  ></v-text-field>
                </template>
              </v-edit-dialog>
            </td>
            <td>{{ props.item.membership }}</td>
            <!-- <td>
              <v-select
                v-model="props.item.profile_status"
                :items="profileStatusList"
                height="30px"
                @change="statusUpdate(props.item, 'status')"
              ></v-select>
            </td> -->
            <td class="lh-25">
              <span class="pf-font-12" v-if="!props.item.profile_status || !props.item.profile_status.length">--</span>
              <v-chip v-else small @input="addStatusItem(props.item, props.index, accountStatus)" v-for="(accountStatus, s) in props.item.profile_status" close :key="s">{{ accountStatus }}</v-chip>
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn icon class="ma-0" title="Add more" v-on="on">
                    <v-icon size="20" class="pf-text-teal">add</v-icon>
                  </v-btn>
                  <v-btn v-if="props.item.status_history && props.item.status_history.length" icon class="ma-0" title="Status history" v-on="on" @click.stop="showStatusHistory(props.item)">
                    <v-icon size="20" class="pf-text-teal">history</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-tile
                    v-for="(item, index) in profileStatusList"
                    :key="index"
                    @click="props.item.profile_status.indexOf(item) > -1 ? {} : addStatusItem(props.item, props.index, item)"
                    :disabled="props.item.profile_status.indexOf(item) > -1"
                  >
                    <v-list-tile-title>{{ item }}</v-list-tile-title>
                    <!-- <v-icon title="Add" v-if="props.item.profile_status.indexOf(item) === -1" size="20" class="ml-2 pf-text-teal">add_circle</v-icon> -->
                    <!-- <v-icon title="Remove" v-if="props.item.profile_status.indexOf(item) > -1" size="20" class="ml-2 pf-text-red">cancel</v-icon> -->
                  </v-list-tile>
                </v-list>
              </v-menu>
              <!-- <v-btn icon class="ma-0" @click="editItem(props.item)">
                <v-icon size="22" color="pf-text-teal">edit</v-icon>
              </v-btn> -->
            </td>
            <!-- <td>
              <span>{{ props.item.task && props.item.task.length ? 'Total: ' + props.item.task.length : 'None' }}</span>
              <template v-if="props.item.task.length">
                <template v-if="props.item.task.filter(x => x.status === 'Open').length"><br><span>Open: {{ props.item.task.filter(x => x.status === 'Open').length }}</span></template>
                <template v-if="props.item.task.filter(x => x.status === 'In-Progress').length"><br><span>Progress: {{ props.item.task.filter(x => x.status === 'In-Progress').length }}</span></template>
                <template v-if="props.item.task.filter(x => x.status === 'Closed').length"><br><span>Closed: {{ props.item.task.filter(x => x.status === 'Closed').length }}</span></template>
              </template>
            </td> -->
            <td align="right">
              <v-btn icon small class="mr-0 ml-0">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                <v-icon size="22" class="pf-text-teal" v-on="on">info</v-icon>
                </template>
                  <span>Linked to {{props.item.agency.length}} {{ props.item.agency.length === 1 ? 'Agency' : 'Agencies' }}</span>
                  <br>
                  <span v-html="getAgencyNames(props.item.agency)"></span>
                </v-tooltip>
              </v-btn>
              <!-- <v-btn icon class="ma-0" :title="`Linked to ${props.item.agency.length} ${props.item.agency.length === 1 ? 'Agency' : 'Agencies'}`">
                <v-icon size="20" class="pf-text-teal">info</v-icon>
              </v-btn> -->
              <!-- <v-btn icon class="ma-0" title="Dashboard" @click="logonFamily(props.item)">
                <v-icon size="20" color="grey darken-2">call_made</v-icon>
              </v-btn> -->
              <!-- <v-btn icon class="ma-0" title="History" @click="getHistory(props.item)">
                <v-icon size="20" color="grey darken-2">history</v-icon>
              </v-btn> -->
              <!-- <v-btn icon class="ma-0" title="Message" @click="messageAdd(props.item)">
                <v-icon size="20" color="grey darken-2">message</v-icon>
              </v-btn> -->
              <!-- <v-btn icon class="ma-0" title="Profile">
                <a :href="`${config.host}view-our-families/#/profile/${props.item.id}`" target="_blank">
                  <v-icon size="20" color="grey darken-2">person</v-icon>
                </a>
              </v-btn> -->
              <!-- <v-btn icon class="ma-0" title="View" :target="props.item.nickname ? '_blank' : ''" :href="(props.item.nickname ? config.WPParams.host + 'profile/' + props.item.nickname : 'javascript:void(0)')">
                <v-icon size="20" color="grey darken-2">remove_red_eye</v-icon>
              </v-btn> -->
              <!-- <v-btn icon class="ma-0" @click="AccountSettings(props.item)" title="Settings">
                <v-icon size="20" color="grey darken-2">settings</v-icon>
              </v-btn> -->
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                <v-btn icon small class="mr-0 ml-0" v-on="on">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                  <v-icon size="22" color="grey darken-2" v-on="on">apps</v-icon>
                  </template>
                    <span>More</span>
                  </v-tooltip>
                </v-btn>
                </template>
                <v-list class="familyOptions">
                  <v-list-tile @click="accountInfo(props.item)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">account_circle</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                     Account Info
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="getNotesList(props.item)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">note</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                     Notes
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="addNotes(props.item)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">note_add</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Add Note
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="messageAdd(props.item)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">message</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Message
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="logonFamily(props.item)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">call_made</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Dashboard
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile :href="`${config.host}view-our-families/#/profile/${props.item.id}`" target="_blank">
                    <v-list-tile-action>
                      <v-btn icon class="ma-0">
                          <v-icon size="22" color="grey darken-2">person</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Profile
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile :target="props.item.nickname ? '_blank' : ''" :href="(props.item.nickname ? config.WPParams.host + 'profile/' + props.item.nickname : 'javascript:void(0)')">
                    <v-list-tile-action>
                      <v-btn icon class="ma-0">
                          <v-icon size="22" color="grey darken-2">remove_red_eye</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      View
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="syncTemplate(props.item)" v-if="props.item.contactInfo && props.item.contactInfo.website">
                    <v-list-tile-action>
                      <v-btn icon class="ma-0">
                          <v-icon size="22" color="grey darken-2">badge</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Sync Website Template
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="videoProject(props.item)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">slideshow</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                     Video
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="AccountSettings(props.item)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">settings</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Settings
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="getHistory(props.item)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">history</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      History
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="resetPassword(props.item)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">lock</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Reset Password
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                  <v-list-tile @click="changeUsername(props.item, props.index)">
                    <v-list-tile-action>
                      <v-btn icon small class="mr-0 ml-0">
                        <v-icon size="22" color="grey darken-2">account_box</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                    <v-list-tile-content>
                    <v-list-tile-title >
                      Change Username / Display Name
                    </v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-card>
    <template>
      <div class="text-xs-center">
        <v-dialog
          v-model="isHistoryActive"
          width="700"
        >
          <v-card>
            <v-card-title
              class="pf-bg-teal pf-pos-relative headline white--text"
            >
              History &nbsp; <small>-&nbsp; {{ (historyUsername ? historyUsername : 'Unknown') }}</small>
              <v-btn class="pf-icon-top-right" icon dark @click="isHistoryActive = false">
                <v-icon>close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text>
              <app-history :data="historyList"></app-history>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="white"
                flat
                @click="isHistoryActive = false"
                class="pf-bg-pink"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>

      <v-dialog
          v-model="isStatusHistoryActive"
          width="70%"
        >
        <v-card>
          <v-card-title
            class="pf-bg-teal pf-pos-relative headline white--text"
          >
            Status history &nbsp; <small>-&nbsp; {{ (historyUsername ? historyUsername : 'Unknown') }}</small>
            <v-btn class="pf-icon-top-right" icon dark @click="isStatusHistoryActive = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="statusHistoryHeaders"
              :items="statusHistory"
              no-data-text="No records found"
              :pagination.sync="historyPagination" 
              class="pf-data-table"
            >
              <template v-slot:items="props">
                <tr class="cursor-pointer">
                  <td>{{ props.index + 1 }}</td>
                  <td>{{ formatDate(props.item.date, 'MM/DD/YYYY hh:mm') }}</td>
                  <td>{{ props.item.status }}</td>
                  <td>{{ props.item.type }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="white"
              flat
              @click="isStatusHistoryActive = false; statusHistory = []"
              class="pf-bg-pink"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </div>
</template>
<script>
/* global session store moment config */
import swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import appHistory from '../History/list';
import { create, getOne, getCollection, update, formatDate, request } from '../../helpers/helpers';

// This allows admin to search for the families by nickname, PPN or status.
export default {
  name: 'ListFamily',
  components: { appHistory },
  data: () => ({
    entity: 'Account',
    menu: [],
    waitingPicker: [],
    pickerDate: '',
    config: config,
    familyList: [],
    unChangedList: [],
    query: {
      family: '',
      status: '',
    },
    historyUsername: '',
    isHistoryActive: false,
    historyList: [],
    max8chars: v => v.length <= 8 || 'Input too long!',
    required: v => !!v || 'Nickname is required.',
    isSearchBoxDisabled: false,
    profileStatusList: ['New', 'Open', 'Layout', 'Video', 'Writing'],
    pagination: {
      rowsPerPage: config.dom.rowsPerPage
    },
    headers: [
      { text: 'Family Name', value: 'name', align: 'left' },
      { text: 'Display Name', value: 'nickname' },
      { text: 'Username', value: 'human[0].user.username' },
      { text: 'Join Date', value: 'joined_date' },
      { text: 'Waiting Since', value: 'waiting_for' },
      { text: 'PPN', value: 'ppn' },
      { text: 'Membership', value: 'membership' },
      { text: 'Status', value: 'profile_status' },
      // { text: 'Tasks', value: '' },
      { text: '', sortable: false },
    ],
    membershipList: [
      'Featured',
      'Network',
      'Basic'
    ],
    statusTexts: {
      'New': 'pf-text-blue',
      'Open': 'pf-text-red',
      'Completed': 'pf-text-green'
    },
    statusHistory: [],
    isStatusHistoryActive: false,
    historyPagination: {
      rowsPerPage: config.dom.rowsPerPage,
      sortBy: 'date',
      descending: true
    },
    statusHistoryHeaders: [
      { text: '#', value: 'id', align: 'left' },
      { text: 'Date & Time', value: 'date' },
      { text: 'Status', value: 'status' },
      { text: 'Type', value: 'type' },
    ],
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(['Agency']),
    SearchResult: {
      set (value) {
        store.commit('setSearchResult', value);
      },
      get () {
        return store.state.SearchResult;
      }
    },
    AgencyList: {
      set (value) {
        store.commit('setAgencyList', value);
      },
      get () {
        return store.state.AgencyList;
      }
    },
  },

  created () {
    window.getApp.$on('SearchResultUpdate', list => {
      this.SearchResult = this.familyList = list;
    });
    if (this.SearchResult.length) {
      this.familyList = this.SearchResult;
    }
    this.initializeAgencyList();
    this.getAdminSettings();
  },

  mounted: function () {
    if (this.$route.params.profileStatus) {
      this.query.status = this.$route.params.profileStatus;
      this.searchFamilies('status');
    }
  },
  methods: {
    dateFormate (date) {
      if (!date) return '';
      let dateString = date.substr(0, 10);
      const [year, month, day] = dateString.split('-');
      return `${month}/${day}/${year}`;
    },
    changeJoinDate (e, item, field) {
      this.menu = [];
      this.waitingPicker = [];
      this.waitingPicker.push(false);
      this.menu.push(false);
      let itemIndex = this.familyList.indexOf(item);
      if (field === 'join') {
        this.familyList[itemIndex].joined_date = new Date(e).toISOString();
      } else {
        this.familyList[itemIndex].waiting_for = new Date(e).toISOString();
      }
      this.statusUpdate(item, 'joinDate');
    },
    getAgencyNames (agencyList) {
      if (agencyList.length) {
        let agencyId = agencyList.map(agency => agency.agency);
        let list = this.AgencyList.filter(agency => agencyId.indexOf(agency.id) !== -1);
        let names = list.map(agency => agency.name);
        return names.join(', <br>');
      }
    },
    async initializeAgencyList () {
      if (!this.AgencyList.length) {
        let where = { _id: { $ne: this.Agency.id }, is_admin: false };
        let attributes = 'name,nickname,email,createdAt,_id,mapping_id';
        let populate = [{ path: 'human', select: '_id user' }];
        let { error, data } = await getCollection('Agency', true, 0, populate, where, attributes, null, { name: 1 });
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            store.commit('setAgencyList', data);
          }
        }
      }
    },
    async getAdminSettings () {
      let where = { is_super_admin: true };
      let attributes = 'account_settings';
      let { error, data } = await getCollection('Agency', true, 0, '', where, attributes);
      if (error) {
        console.log(error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Failed to load account settings'
        };
      } else {
        if (data.length > 0) {
          this.profileStatusList = data[0] && data[0].account_settings && data[0].account_settings.statuses && data[0].account_settings.statuses.length ? data[0].account_settings.statuses : this.profileStatusList;
        }
      }
    },
    // async nicknameUpdate (item) {
    //   let where = { 'nickname': item.nickname };
    //   let { error, data } = await getCollection('Account', true, 0, '', where);
    //   if (error) {
    //     console.log(error);
    //   } else {
    //     if (data.length > 0 && item.id !== data[0].id) {
    //       swal.fire({
    //         title: 'The entered nickname already exists',
    //         type: 'error',
    //         confirmButtonColor: '#3085d6',
    //         confirmButtonText: 'Close',
    //         allowOutsideClick: false
    //       }).then((result) => {
    //         if (result.value) {
    //           this.familyList = JSON.parse(JSON.stringify(this.unChangedList));
    //         }
    //       });
    //     } else {
    //       this.statusUpdate(item, 'nickname');
    //     }
    //   }
    // },
    async getHistory (family) {
      let humanIds = Array.from(family.human, x => x.id);
      let sort = { 'createdAt': -1 };
      let where = { '$or': [{ 'entity': 'Account', 'document_id': family.id }, { 'entity': 'Human', 'document_id': { '$in': humanIds }}], 'updatedBy': { '$exists': true }};
      let populate = { path: 'updatedBy', select: 'entity updatedBy createdAt', populate: { path: 'human', select: 'first_name last_name' }};
      if (family.human && family.human.length) {
        where['$or'].push({ 'entity': 'User', 'document_id': family.human[0].user.id });
      }
      let { error, data } = await getCollection('History', true, 10, populate, where, null, null, sort);
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Something went wrong, please try again.'
        };
      } else {
        this.historyList = data;
        this.isHistoryActive = true;
        this.historyUsername = family.human[0].first_name + ' ' + family.human[0].last_name;
      }
    },
    // @vuese
    // Used to search for families on entering nickname, PPN or the status
    // @arg The type of search - family or status
    async searchFamilies (searchType) {
      this.familyList = [];
      let profile_number = this.query.family;
      let profile_year = this.query.family;
      if ((this.query.family && this.query.family.length && this.query.family.length > 2) || (this.query.status && !this.query.family.length) || (this.query.status && this.query.family.length > 2)) {
        // let where = { 'agency.status': { '$nin': ['Rejected'] }};
        let where = {};
        if (this.query.family && this.query.family.length > 2) {
          // this.isSearchBoxDisabled = true;
          if (!where.$or) {
            where.$or = [{
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            }, {
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }, {
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            }];
          } else {
            where.$or.push({
              $expr: {
                $eq: [this.query.family, {
                  $concat: [{
                    '$toString': '$profile_year'
                  }, '_', {
                    '$toString': '$profile_number'
                  }]
                }]
              }
            });
            where.$or.push({
              'nickname': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
            where.$or.push({
              'name': { $regex: `.*` + this.query.family + `.*`, $options: 'i' }
            });
          }
        }
        if (this.query.family && !isNaN(this.query.family)) {
          where.$or.push({
            'profile_number': this.query.family
          });
        }
        if (this.query.status) {
          where.profile_status = this.query.status;
        }
        let sort = { 'agency.updatedAt': -1 };
        let populate = [{ 'path': 'human', populate: { path: 'user', select: 'username access' }}, 'contactInfo.country', 'contactInfo.state'];
        let attributes = `membership,account_type,agency,nickname,name,contactInfo.email,contactInfo.website,profile_year,mapping_id,
        profile_number,joined_date,waiting_for,task,profile_status,status_history,status,video_app_settings,is_private,allow_contact,placement_status`;
        let { error, data } = await getCollection(this.entity, true, 0, populate, where, attributes, null, sort);
        // this.$refs.searchField.focus();
        // this.isSearchBoxDisabled = false;
        if (error) {
          console.log(error);
          this.snackbar = {
            show: true,
            color: 'red',
            text: 'Failed to load client list'
          };
        } else {
          if (data.length > 0) {
            this.unChangedList = JSON.parse(JSON.stringify(data));
            this.familyList = data;
            this.SearchResult = this.familyList;
          }
        }
      }
    },
    // @vuese
    // Used to format the mongo date string
    // @arg The mongo date string
    formatDate (dateString, format = 'MM/DD/YYYY') {
      if (dateString) {
        return formatDate(dateString, format);
      }
    },
    // @vuese
    // Used to update the family status
    // @arg The account object to be updated
    async statusUpdate (item, mode) {
      let updateItem = JSON.parse(JSON.stringify(item));
      if (mode === 'nickname') {
        updateItem.updated_from = 'nickName';
      } else if (mode === 'joinDate') {
        updateItem.updated_from = 'parentInfo';
      } else {
        updateItem.updated_from = 'default';
      }
      this.unChangedList = JSON.parse(JSON.stringify(this.familyList));
      let itemIndex = this.familyList.indexOf(item);
      let updateId = this.familyList[itemIndex].id;
      updateItem.human[0].user = updateItem.human[0].user.id;
      if (updateItem.human.length === 2 && updateItem.human[1].user) {
        updateItem.human[1].user = updateItem.human[1].user.id;
      }
      let { error, data, status } = await update(this.entity, updateItem, updateId);
      if (error) {
        console.log('error', error);
        swal.fire({
          type: 'error',
          title: 'Failed to update data',
          showConfirmButton: true,
          timer: 2500,
          onClose: () => {}
        });
      } else {
        if (mode === 'status') {
          // Create the timeline
          let timelineData = {
            title: 'Profile Status Changed',
            text: `Your profile status was updated`,
            account: item.id
          };
          let { error, data, status } = await create('Timeline', timelineData);
          if (error) {
            console.log('error', error);
            this.snackbar = {
              show: true,
              color: 'orange',
              text: 'Failed to create the timeline'
            };
          } else {
            swal.fire({
              type: 'success',
              title: 'Details saved successfully',
              showConfirmButton: false,
              timer: 2500,
              onClose: () => {
              }
            });
          }
        } else {
          let text = '';
          if (mode === 'nickname') {
            text = 'NickName changed successfully';
          } else if (mode === 'joinDate') {
            text = 'Account Details updated successfully';
          } else {
            text = 'Details saved successfully';
          }
          swal.fire({
            type: 'success',
            title: text,
            showConfirmButton: false,
            timer: 2500,
            onClose: () => {
            }
          });
        }
      }
    },
    // @vuese
    // Used to login to the family dashboard by admin
    // @arg The family object to which admin wants to login
    async logonFamily (family) {
      let sessionData;
      // console.log('sessionData', sessionData);
      let { error, data } = await getOne('User', family.human[0].user.id);
      if (error) {
        console.log('error', error);
        this.snackbar = {
          show: true,
          color: 'red',
          text: 'Something went wrong, please try again.'
        };
      } else {
        delete data.access;
        sessionData = { ...session.getSession() };
        sessionData.adminUser = session.getSession().user;
        sessionData.user = data;
        session.setSession(sessionData, false);
        // window.location = config.client;
        location.reload();
      }
    },
    // @vuese
    // Used to let admin message to a particular family
    // @arg The account object to which admin wants to message
    messageAdd (item) {
      let familyItem = {
        id: item.id,
        // avatar: item.avatar ? item.avatar : '',
        human: item.human[0].id,
        name: item.name,
        role: 'parent',
        _id: item.id
      };
      this.$router.push({ name: 'adminAddMessage', params: { item: familyItem, preUrl: '/admin/families' }});
    },
    AccountSettings (item) {
      // let familyItem = {
      //   id: item.id,
      //   human: item.human[0].id,
      //   name: item.name,
      //   role: '',
      //   _id: item.id
      // };
      this.$router.push({ name: 'AccountSettings', params: { item: item, preUrl: '/admin/families' }});
    },
    videoProject (item) {
      let humnanId = {
        id: item.id,
        human: item.human[0].id,
        ppn: item.ppn,
        access: item.human[0].user.access
      };
      this.$router.push({ name: 'VideoProject', params: { item: humnanId, preUrl: '/admin/families' }});
    },
    async syncTemplate (item) {
      let { error, data } = await request(`Account/createTemplate/${item.id}`, 'GET');
      if (error) {
        console.log('error', error);
        swal.fire({
          type: 'warning',
          title: 'Error',
          text: 'Something went wrong, please try again.',
          showConfirmButton: true,
          onClose: () => {}
        });
        return;
      } else {
        /* Update the membership status in state */
        swal.fire({
          type: 'success',
          title: 'Success',
          text: 'The website template sync has been initiated successfully. It may take around 30 seconds to reflect the changes on the website.',
          showConfirmButton: false,
          timer: 2500,
          onClose: () => {
            // 
          }
        });
      }
    },
    accountInfo (item) {
      if (!item || !item.id) {
        return;
      }
      this.$router.push({ path: `/admin/account/${item.id}`, params: { preUrl: '/admin/families' }});
    },
    resetPassword (item) {
      let familyItem = {
        name: item.nickname,
        mapping_id: item.mapping_id,
        id: item.id,
        email: item.contactInfo ? item.contactInfo.email : '',
        username: item.human[0].user.username,
        user_id: item.human[0].user.id
      };
      this.$router.push({ name: 'ResetPassword', params: { item: familyItem, preUrl: '/admin/families' }});
    },
    changeUsername (item, itemIndex) {
      let familyItem = {
        accountId: item.id,
        userId: item.human[0].user._id,
        searchResultIndex: itemIndex
      };
      this.$router.push({ name: 'ChangeUsername', params: { item: familyItem, preUrl: '/admin/families' }});
    },
    getNotesList (item) {
      /* let accountId = {
        id: item.id
      };
      this.$router.push({ name: 'NotesList', params: { item: accountId, preUrl: '/admin/families' }}); */
      if (!item || !item.id) {
        return;
      }
      this.$router.push({ path: `/admin/account/${item.id}`, query: { preUrl: '/admin/families', section: 'notes' }});
    },
    addNotes (item) {
      /* let accountId = {
        id: item.id
      };
      this.$router.push({ name: 'AddNotes', params: { item: accountId, preUrl: '/admin/families' }}); */
      if (!item || !item.id) {
        return;
      }
      this.$router.push({ path: `/admin/account/${item.id}`, query: { preUrl: '/admin/families', section: 'addNote' }});
    },
    async addStatusItem (account, accountIndex, item) {
      if (item && account.profile_status) {
        let index = account.profile_status.indexOf(item);
        if (index > -1) {
          account.profile_status.splice(index, 1);
        } else {
          account.profile_status.push(item);
        }

        if (!account.status_history || !account.status_history.length) {
          account.status_history = [];
        }
        account.status_history.push({ status: item, type: index > -1 ? 'Removed' : 'Added', date: (new Date()).toISOString() });

        await this.statusUpdate(account, 'status');

        this.familyList[accountIndex] = account;
        this.familyList = this.familyList;

      }
    },
    showStatusHistory (account) {
      if (account && account.status_history && account.status_history.length) {
        this.statusHistory = account.status_history;
        this.isStatusHistoryActive = true;
        this.historyUsername = account.name;
      }
    }
  }
};
</script>
<style scoped>

  .familyOptions {
    height: 500px;
    overflow-y: scroll;
  }

</style>



// WEBPACK FOOTER //
// src/pages/Families/list.vue